var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGiGstar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 283.46 283.96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M106.03,123.43c-2.41-1.75-5.36-2.62-8.85-2.62s-6.29.84-8.83,2.51c-2.54,1.67-4.51,4.12-5.92,7.33-1.41,3.21-2.11,7.05-2.11,11.5s.69,8.38,2.08,11.61c1.39,3.23,3.35,5.69,5.9,7.37,2.54,1.69,5.53,2.53,8.97,2.53,3.05,0,5.68-.54,7.91-1.64,2.23-1.09,3.94-2.65,5.16-4.68,1.21-2.03,1.84-4.41,1.91-7.13h-14.08v-10.13h27.08v8.07c0,5.59-1.19,10.45-3.56,14.59-2.38,4.14-5.69,7.32-9.93,9.53-4.24,2.21-9.1,3.32-14.57,3.32-6.04,0-11.36-1.35-15.98-4.06-4.62-2.7-8.2-6.56-10.76-11.57-2.56-5.01-3.83-10.89-3.83-17.64s1.31-12.79,3.94-17.84c2.63-5.05,6.25-8.91,10.85-11.59,4.6-2.67,9.77-4.01,15.51-4.01,4.81,0,9.21.92,13.2,2.76,3.99,1.84,7.25,4.41,9.8,7.71,2.54,3.3,4.11,7.08,4.71,11.32h-13.63c-.9-3.08-2.55-5.49-4.95-7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M148.55,174.69h-13.45v-64.91h13.45v64.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-fg",
    fill: "#262e71",
    d: "M197.66,123.43c-2.41-1.75-5.36-2.62-8.85-2.62s-6.29.84-8.83,2.51c-2.54,1.67-4.51,4.12-5.92,7.33-1.41,3.21-2.11,7.05-2.11,11.5s.69,8.38,2.08,11.61c1.39,3.23,3.35,5.69,5.9,7.37,2.54,1.69,5.53,2.53,8.97,2.53,3.05,0,5.68-.54,7.91-1.64,2.23-1.09,3.94-2.65,5.16-4.68,1.21-2.03,1.84-4.41,1.91-7.13h-14.08v-10.13h27.08v8.07c0,5.59-1.19,10.45-3.56,14.59-2.38,4.14-5.69,7.32-9.93,9.53-4.24,2.21-9.1,3.32-14.57,3.32-6.04,0-11.36-1.35-15.98-4.06-4.62-2.7-8.2-6.56-10.76-11.57-2.56-5.01-3.83-10.89-3.83-17.64s1.31-12.79,3.94-17.84c2.63-5.05,6.25-8.91,10.85-11.59,4.6-2.67,9.77-4.01,15.51-4.01,4.81,0,9.21.92,13.2,2.76,3.99,1.84,7.25,4.41,9.8,7.71,2.54,3.3,4.11,7.08,4.71,11.32h-13.63c-.9-3.08-2.55-5.49-4.95-7.24Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "gnb-icon-bg",
    cx: 141.73,
    cy: 142.23,
    r: 141.73,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-ring",
    fill: "#262e71",
    stroke: "#262e71",
    strokeMiterlimit: 10,
    d: "M69.43,53.51l-33.49,24.34c-12.82-.31-24.86,7.74-29.03,20.56s.84,26.41,11.4,33.69l12.79,39.37c-3.01-11.31-4.29-23.16-3.67-35.14,15.22,4.13,31.16-4.37,36.09-19.53,4.93-15.16-2.97-31.41-17.72-37.01,6.54-10.06,14.54-18.89,23.62-26.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-ring",
    fill: "#262e71",
    stroke: "#262e71",
    strokeMiterlimit: 10,
    d: "M35.1,183.54l12.76,39.38c-4.27,12.09-.35,26.04,10.55,33.97s25.37,7.38,35.57-.4l41.4.04c-11.69-.65-23.34-3.1-34.55-7.4,8.65-13.19,5.5-30.98-7.39-40.36s-30.79-6.91-40.68,5.37c-7.54-9.34-13.46-19.68-17.66-30.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-ring",
    fill: "#262e71",
    stroke: "#262e71",
    strokeMiterlimit: 10,
    d: "M148.09,256.54l41.4-.04c10.19,7.78,24.67,8.33,35.57.4,10.9-7.93,14.82-21.88,10.55-33.97l12.76-39.39c-4.21,10.92-10.12,21.26-17.66,30.6-9.89-12.28-27.79-14.76-40.68-5.37-12.89,9.38-16.03,27.17-7.39,40.36-11.2,4.3-22.86,6.76-34.55,7.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-ring",
    fill: "#262e71",
    stroke: "#262e71",
    strokeMiterlimit: 10,
    d: "M252.36,171.47l12.79-39.37c10.56-7.28,15.57-20.87,11.4-33.69s-16.21-20.87-29.03-20.56l-33.49-24.34c9.08,7.38,17.08,16.21,23.62,26.28-14.74,5.6-22.64,21.85-17.72,37.01,4.93,15.16,20.87,23.67,36.09,19.53.62,11.99-.66,23.83-3.67,35.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "gnb-icon-ring",
    fill: "#262e71",
    stroke: "#262e71",
    strokeMiterlimit: 10,
    d: "M203.75,46.09l-33.49-24.33c-3.66-12.29-15.04-21.25-28.52-21.25s-24.86,8.96-28.52,21.25l-33.49,24.33c9.83-6.35,20.7-11.23,32.29-14.35.77,15.75,13.78,28.28,29.73,28.28s28.96-12.53,29.73-28.28c11.59,3.11,22.46,7.99,32.29,14.34Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiGstar);
export default __webpack_public_path__ + "static/media/GIGstar.5ceb5fbc662f54ee84e04bdf3a0b01d0.svg";
export { ForwardRef as ReactComponent };